export default __webpack_public_path__ + "static/media/6.e8ff86b6.jpeg";